<template>
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.79412 2.89361C4.79412 1.84346 5.9425 1.19723 6.84015 1.74223L15.0593 6.73241C15.6352 7.08209 15.6352 7.91791 15.0593 8.26759L6.84015 13.2578C5.9425 13.8028 4.79412 13.1565 4.79412 12.1064V2.89361Z" fill="#6B7E99"/>
        <rect opacity="0.5" x="0.676407" y="3.79401" width="2.47059" height="7.82353" rx="1.23529" fill="#6B7E99"/>
    </svg>

</template>

<script>
    export default {
        name:"MediaArrow"
    }
</script>